import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const ArrowLeft: FC<Props> = ({ className }) => (
  <svg
    className={classNames('stroke-[1.5px]', className)}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.1775 13.5525L2.625 8.99999L7.1775 4.44749M15.375 8.99999L2.7525 8.99999"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeft;
